import { render } from "./post-smtp-app-wrapper.vue?vue&type=template&id=3112b8ca&scoped=true"
import script from "./post-smtp-app-wrapper.vue?vue&type=script&lang=js"
export * from "./post-smtp-app-wrapper.vue?vue&type=script&lang=js"

import "./post-smtp-app-wrapper.vue?vue&type=style&index=0&id=3112b8ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3112b8ca"]])

export default __exports__